@if (status) {
  <div class="banner-text store-status-banner">Store is in {{ status | titlecase }} mode!</div>
}
@if (popup) {
  @switch (popup.lifecycle_phase) {
    @case ('before_start') {
      <div class="banner-text store-status-banner">
        Ordering opens {{ popup.checkout_starts_at | date: 'MMM d, h:mm a' }}.
      </div>
    }
    @case ('active_checkout') {
      <div class="banner-text store-status-banner">
        Ordering closes {{ popup.checkout_ends_at | date: 'MMM d, h:mm a' }}.
      </div>
    }
    @case ('view_only') {
      <div class="banner-text store-status-banner">This store is closed for orders.</div>
    }
  }
}
@if (giftToken() && !isKitRoute()) {
  <div class="banner-text gifting-banner">
    You are in Gifting mode. Please
    <a href="#" (click)="resumeGifting($event)">continue with selection</a>
    or
    <a href="#" (click)="discardGifting($event)">discard Gifting and use store normally</a>
  </div>
}
@if (alertText()) {
  <div class="banner-text" [style.background-color]="alertTextBackground()">
    {{ alertText() }}
  </div>
}
@if (alerts().length) {
  @for (alert of alerts(); track alert.id) {
    <div class="alert-banner  {{ alert.type }}">
      {{ alert.message }}
    </div>
  }
}
